import Separator from 'components/Separator';
import './openHouse.scss'
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import actions from 'store/actions';
import moment from 'moment';

const OpenHouse = ({ data }) => {
    const dispatch = useDispatch();
    const [openHouse, setOpenHouse] = useState(null);


    useEffect(() => {
        const init = async () => {
            const events = await dispatch(actions.listing.fetchListingEventsStartEnd(
                {
                    listing: data.id,
                    start: moment().startOf('day').format('YYYY-MM-DDTHH:mm:ss').toString(),
                    end: moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss').toString()
                }
            ));
            events.filter(item => item.event_type === 'open_house');
            setOpenHouse(events[0]);
        }
        init()
    }, [])

    const convertTime = (value) => {
        let time_string = value;
        const H = +time_string.substr(0, 2);
        let h = (H % 12) || 12;
        const ampm = H < 12 ? " am" : " pm";
        time_string = h + time_string.substr(2, 3) + ampm;

        return time_string;
    }

    return (
        <div className='open-house-container'>
            <div className='date-today'>
                <p>Open House</p>
                <p className='date'>{moment().format('MMMM D, YYYY')} <span>{moment().format('dddd')}</span></p>
            </div>
            <Separator height={8} />
            <div className='open-house-sched'>
                <div className='availability'>
                    <p className='time'>{convertTime(data.availability_start)} - {convertTime(data.availability_end)}</p>
                </div>
                <div className={`${openHouse && 'active'} open-house`}>
                    <p>{openHouse ? `${moment(openHouse.start, 'YYYY-MM-DDTHH:mm:ss').format("hh:mm A")} - ${moment(openHouse.end, 'YYYY-MM-DDTHH:mm:ss').format("hh:mm A")}` : 'No open house for today'}</p>
                </div>
            </div>
        </div>
    )
}


export default OpenHouse;